var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m68.301 39c1-1 1-2.5 0-3.5l-3.8984-3.8984c-1-1-2.5-1-3.5 0l-8.5 8.5c-1.3984 1.3984-3.5 1.3984-4.8984 0l-8.5039-8.4023c-1-1-2.5-1-3.5 0l-3.8984 3.8984c-1 1-1 2.5 0 3.5l8.5 8.5c1.3984 1.3984 1.3984 3.5 0 4.8984l-8.4023 8.5039c-1 1-1 2.5 0 3.5l3.8984 3.8984c1 1 2.5 1 3.5 0l8.5-8.5c1.3984-1.3984 3.5-1.3984 4.8984 0l8.5 8.5c1 1 2.5 1 3.5 0l3.8984-3.8984c1-1 1-2.5 0-3.5l-8.5-8.5c-1.3984-1.3984-1.3984-3.5 0-4.8984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 2.5c-26.199 0-47.5 21.301-47.5 47.5s21.301 47.5 47.5 47.5 47.5-21.301 47.5-47.5-21.301-47.5-47.5-47.5zm0 84.602c-20.5 0-37.102-16.602-37.102-37.102s16.602-37.102 37.102-37.102 37.102 16.602 37.102 37.102-16.602 37.102-37.102 37.102z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2ef5696115e574f714d365986691f0d9.svg";
export { ForwardRef as ReactComponent };